import { Component } from '@angular/core';

@Component({
  selector: 'allas-marcas-de-filtros',
  imports: [],
  template: `
    <section class="grid grid-cols-12 bg-allasRed mt-12 gap-2 xl:gap-0">
      <div class="col-span-12 xl:col-span-3 order-1 xl:order-none">
        <img
          class="w-full h-full object-cover"
          src="/images/services/cambio-filtros/filtro-filtrando.webp"
          alt="Filtros filtrando"
        />
      </div>
      <div
        class="col-span-12 xl:col-span-6 flex items-center justify-center p-2 xl:p-0 order-3 xl:order-none"
      >
        <p
          class="text-white text-center xl:text-justify text-sm xl:text-2xl fs-condensed opacity-90 px-6 xl:px-0 pb-4 xl:pb-0"
        >
          En Allas Repuestos trabajamos únicamente con <br />
          filtros de marcas reconocidas, garantizando la <br />
          máxima protección y durabilidad para tu vehículo.
        </p>
      </div>
      <div
        class="col-span-12 xl:col-span-3 flex flex-col items-center justify-center p-2 xl:p-0 order-2 xl:order-none"
      >
        <div class="flex flex-col items-center xl:items-start">
          <!-- Versión Mobile -->
          <h1 class="text-3xl fs-condensed text-white block xl:hidden">
            FILTROS DE LA MEJOR
          </h1>

          <!-- Versión Desktop -->
          <h1 class="text-4xl fs-condensed text-white hidden xl:block">
            FILTROS
          </h1>
          <h1 class="text-4xl fs-condensed text-white hidden xl:block">
            DE LA MEJOR
          </h1>

          <!-- Ambas Versiones -->
          <h1 class="text-5xl xl:text-6xl font-bold fs-condensed text-white">
            CALIDAD
          </h1>
        </div>
      </div>
    </section>
    <section class="mt-6 flex items-center justify-center">
      <img
        src="/images/services/cambio-filtros/marcas-filtros.webp"
        alt="Marcas de filtros"
        class="w-2/3 h-auto object-contain hidden xl:block"
      />
      <img
        src="/images/services/cambio-filtros/marcas-filtros-mobile.webp"
        alt="Marcas de filtros"
        class="w-full h-auto object-contain block xl:hidden"
      />
    </section>
  `,
})
export class MarcasDeFiltros {}
